import { AccountContext } from '@lib/context/AccountContext/AccountContext'
import { useContext } from 'react'

const useUser = () => {
  const account = useContext(AccountContext)

  if (!account) throw new Error('useUser must be used inside AccountProvider')

  return { account }
}

export default useUser
